<template>
  <title-container title="My Documents" icon="file-contract">
    <borrower-docs
      :documents="documents"
    />
  </title-container>
</template>

<script>
import TitleContainer from '@/components/utils/TitleContainer';
import BorrowerDocs from '@/components/documents/BorrowerDocs';

const EXCLUDED_FOLDERS = [
  'Plaid',
  'Privacy Choices',
  'Privacy Notice',
  'Credit Authorization',
  'Financial Statement',
  'Bank Statement',
  'Tax Returns',
  'Borrower 1098 Form',
  'Borrower Stated Experience',
];

export default {
  components: {
    TitleContainer,
    BorrowerDocs,
  },
  computed: {
    documents() {
      return this.$store.getters.documents
        .filter(category => (!EXCLUDED_FOLDERS.includes(category.type)));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/documents/BorrowerDocsPage.vue